"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function forEachKey(subject, callbackfn, thisArg) {
    return Object.keys(subject).forEach(callbackfn, thisArg);
}
exports.forEachKey = forEachKey;
//# sourceMappingURL=forEachKey.js.map